import React, { FC } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import styles from './SystemStatus.styles';
import theme from '../../../common/theme';
import Icon from '../../Icon/Icon';

export enum STATES {
  POSITIVE = 'positive',
  NEUTRAL = 'neutral',
  NEGATIVE = 'negative',
}

export interface SystemStatusAction {
  testID: string;
  label: string;
  type: STATES;
  action?: () => void;
}

const STATUS_MAPPING = {
  positive: {
    icon: { size: 20, name: 'angle-right' },
    textStyle: undefined,
  },
  negative: {
    icon: { size: 18, name: 'angle-right' },
    textStyle: styles.textNegative,
  },
  neutral: {
    icon: { size: 20, name: 'angle-right' },
    textStyle: styles.textNeutral,
  },
};

const SystemStatusRow: FC<SystemStatusAction> = ({
  testID,
  label,
  type: status,
  action,
}) => {
  const { icon, textStyle } = STATUS_MAPPING[status] || STATUS_MAPPING.neutral;

  return (
    <TouchableOpacity
      testID={testID}
      style={styles.option}
      disabled={!action}
      onPress={() => {
        action?.();
      }}
    >
      <Text style={[styles.text, textStyle]}>{`${label}`}</Text>
      <View style={styles.icon}>
        <Icon size={icon.size} name={icon.name} color={theme.palette.mono500} />
      </View>
    </TouchableOpacity>
  );
};

export default SystemStatusRow;
